import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../../account/angular/models/account.model";

export class serviceAccountUsersTableCtrl implements IController {
  user: any;
  accounts: AccountModel[];
  bindings: any;
  queryString: any;
  rolesGroups: any;
  onRemove: Function;

  private rolesMap: any;
  public groupsMap: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.rolesMap = {};
    this._initRolesMap();
    this._initGroupsMap();
  };

  $onChanges(changes) {
    if (changes.bindings && !changes.bindings.isFirstChange()) {
      this._initRolesMap();
      this._initGroupsMap();
    }

    if (changes.rolesGroups && !changes.rolesGroups.isFirstChange()) {
      this._initGroupsMap();
    }
  };

  private _initRolesMap() {
    this.rolesMap = {};
    _.forEach(this.bindings, (binding) => {
      if (!this.rolesMap[binding.memberId]) {
        this.rolesMap[binding.memberId] = [];
      }
      if(binding.roleId){
        this.rolesMap[binding.memberId].push(binding.roleId);
      }
    });
  }

  private _initGroupsMap() {
    this.groupsMap = {};

    _.forEach(this.bindings, (binding) => {
      if (!this.groupsMap[binding.memberId]) {
        this.groupsMap[binding.memberId] = [];
      }
      if (binding.rolesGroupId) {
        const groupRef = _.find(this.rolesGroups, (g) => {
          return g.id === binding.rolesGroupId;
        })
        if (!!groupRef) {
          this.groupsMap[binding.memberId].push(groupRef);
        }
      }
    });
  }

}

angular
  .module('bringoz.admin.admins')
  .component('serviceAccountUsersTable', {
    bindings: {
      accounts: '<',
      bindings: '<',
      queryString: '<',
      rolesGroups: '<',
      onEdit: '&',
      onRemove: '&'
    },
    template: require('./service-account-users-table.html').default,
    controller: serviceAccountUsersTableCtrl
  });
